import { render, staticRenderFns } from "./ContentBody.vue?vue&type=template&id=d9d356e8&scoped=true"
import script from "./ContentBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentBody.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContentBody.vue?vue&type=style&index=0&id=d9d356e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d356e8",
  null
  
)

export default component.exports